import type { AnchorHTMLAttributes, ReactNode } from 'react'

type SmartLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
  children: ReactNode
}

function isExternalDestination(href: string) {
  if (!/^https?:\/\//i.test(href)) return false
  try {
    return new URL(href, window.location.href).origin !== window.location.origin
  } catch {
    return true
  }
}

export function SmartLink({ href, children, ...props }: SmartLinkProps) {
  const external = isExternalDestination(href)

  return (
    <a
      {...props}
      href={href}
      target={external ? '_blank' : props.target}
      rel={external ? 'noopener noreferrer' : props.rel}
    >
      {children}
    </a>
  )
}
